(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/oddset-kambi/components/sportradar-statistics/assets/javascripts/sportradar-statistics.js') >= 0) return;  svs.modules.push('/modules/oddset-kambi/components/sportradar-statistics/assets/javascripts/sportradar-statistics.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useEffect = _React.useEffect,
  useRef = _React.useRef,
  useState = _React.useState;
const Icon = svs.ui.ReactIcon;
const IconButton = svs.ui.ReactIconButton;
const Modal = svs.components.lbUi.modal.Modal;
const Loader = svs.components.ReactLoader.Loader;
const sportradarMatchUrl = svs.oddset_kambi.data.sportradarMatchUrl;
const SportradarStatisticsIframe = _ref => {
  let betradarId = _ref.betradarId,
    closeModal = _ref.closeModal;
  const iframeSectionRef = useRef(null);
  const _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  useEffect(() => {
    const handleClickOutside = event => {
      if (iframeSectionRef.current && !iframeSectionRef.current.contains(event.target)) {
        closeModal();
      }
    };
    let listenerAdded = false;
    if (betradarId) {
      document.addEventListener('mousedown', handleClickOutside);
      listenerAdded = true;
    }
    return () => {
      if (listenerAdded) {
        document.removeEventListener('mousedown', handleClickOutside);
      }
    };
  }, [betradarId, closeModal]);
  return React.createElement(Modal, {
    isOpen: Boolean(betradarId)
  }, isLoading && React.createElement("div", {
    className: "oddset-sportradar-statistics-loader"
  }, React.createElement(Loader, null)), React.createElement("div", {
    className: "oddset-sportradar-statistics-iframe-container",
    ref: iframeSectionRef
  }, React.createElement("div", {
    className: "oddset-sportradar-statistics-iframe-container__close-btn"
  }, React.createElement(IconButton, {
    "aria-label": "St\xE4ng ut\xF6kad statistik",
    onClick: closeModal
  }, React.createElement(Icon, {
    color: "fc-white",
    icon: "close",
    size: "300"
  }))), React.createElement("iframe", {
    "aria-label": "Ut\xF6kad statistik",
    onLoad: e => {
      e.target.focus();
      setIsLoading(false);
    },
    role: "document",
    src: "".concat(sportradarMatchUrl, "/").concat(betradarId),
    title: "Ut\xF6kad statistik"
  })));
};
setGlobal('svs.oddset_kambi.components.sportradar_statistics.SportradarStatisticsIframe', SportradarStatisticsIframe);

 })(window);